import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";

const dauData = [
  { name: "Mon", users: 120 },
  { name: "Tue", users: 210 },
  { name: "Wed", users: 180 },
  { name: "Thu", users: 300 },
  { name: "Fri", users: 260 },
  { name: "Sat", users: 140 },
  { name: "Sun", users: 170 },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Users" />
          </figure>
          <h2>50</h2>
          <p>Total Users</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Active Users" />
          </figure>
          <h2>15</h2>
          <p>Active Users</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-revenue")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="Revenue" />
          </figure>
          <h2>AED 2000</h2>
          <p>Total Revenue </p>
        </div>
      </div>

      <div className="grid_sc gap_m">
        {/* Daily Active Users Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Users</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Active Users</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Revenue</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
